import React, { Component, PropTypes } from 'react';
import { Link, withRouter } from 'react-router';
import { connect } from 'react-redux';
import { SparkMenu } from '../../ui/spark';
import LeftMainmenuItem from '../../helpers/LeftMainmenuItem';
import AppMenuConfig from '../../../config/Menu';
import {
    // eslint-disable-next-line import/named
    modalGuestInfoActions,
    modalConfirmationSettingsActions,
    modalLabelSettingsActions
} from '../../modals/AllModal';
import { checkPermissionForLevel, checkPermissions } from '../../../../lib/utils';
import { ACCESS_POINTS_GROUP, ACCESS_POINT_LEVEL, CATEGORY_OF_PAGE } from '../../../constants/AccessPoints';
import { get } from 'lodash';

class NavigationPagesComponents extends Component {
    componentDidMount() {
        this.menuInstance = new SparkMenu(this.node);
    }

    isLinkDisabled(elem) {
        if (elem.link === 'general/tracking-hooks') {
            return !this.props.hasAccessToTrackingHooks.view && !this.props.hasAccessToTrackingHooks.edit;
        } else if (elem.link === 'general/policy-urls') {
            return !this.props.permissionConfiguration.view && !this.props.permissionConfiguration.edit;
        }

        if (elem.name === CATEGORY_OF_PAGE.LABELS) {
            return !(this.props.permissionLabels.view || this.props.permissionLabels.edit);
        } else if (elem.name === CATEGORY_OF_PAGE.SETTINGS) {
            return !(this.props.permissionConfiguration.view || this.props.permissionConfiguration.edit);
        } else {
            const children = AppMenuConfig.pages[elem.link];
            if (children) {
                for (const child of children) {
                    // Recurrent function looking for excluded items inside of category and in effect disable previous button
                    if (!this.isLinkDisabled(child)) {
                        return false;
                    }
                }
                return true;
            } else {
                return !(
                    _.get(elem, 'force', false) ||
                    this.props.permissionLabels.view ||
                    this.props.permissionLabels.edit ||
                    this.props.permissionConfiguration.view ||
                    this.props.permissionConfiguration.edit
                );
            }
        }
    }

    clickOnLink(elementTarget, event) {
        event.preventDefault();
        if (elementTarget.link.indexOf('/') === -1) {
            //Find next elements in category
            const elementsInsideCategory = AppMenuConfig.pages[elementTarget.link.split('/')[0]];

            //Verify if settings exist in category
            const isSettingsExist = elementsInsideCategory.filter(obj => {
                return obj.name === 'Settings';
            });

            //Verify if label exist in category
            const isLabelsExist = elementsInsideCategory.filter(obj => {
                return obj.name === 'Labels';
            });

            const settings =
                (this.props.permissionConfiguration.view || this.props.permissionConfiguration.edit) &&
                isSettingsExist.length > 0;
            const labels =
                this.props.permissionLabels.view || (this.props.permissionLabels.edit && isLabelsExist.length > 0);

            //Set correct url for opened category for pages menu
            this.props.router.push(`/pages/${elementTarget.link}${settings ? '/settings' : labels ? '/labels' : ''}`);
            if (elementTarget.link === 'customContent') {
                this.props.router.push(`/pages/customContent/custom-content`);
                return;
            }
        } else {
            this.props.router.push(`/pages/${elementTarget.link}`);
        }
    }

    render() {
        const widgetsExists = AppMenuConfig.pages.children.some((item) => item.link === 'widgets');
        const contentExists = AppMenuConfig.pages.children.some((item) => item.link === 'customContent');
        if (this.props.inContextBeta && !widgetsExists) {
            AppMenuConfig.pages.children.push({ name: 'Widgets', link: 'widgets' });
        }
        if(this.props.inContextBeta && !AppMenuConfig.pages.widgets){
            AppMenuConfig.pages = {
                ...AppMenuConfig.pages,
                widgets: [{ name: 'Labels', link: 'widgets/labels' }],
            };
        }
        if (this.props.inContextBeta && !contentExists) {
            AppMenuConfig.pages.children.push({ name: 'Custom Content', link: 'customContent' });
        }
        if(this.props.inContextBeta && !AppMenuConfig.pages.customContent){
            AppMenuConfig.pages = {
                ...AppMenuConfig.pages,
                customContent: [{ name: 'Custom Content', link: 'customContent/custom-content' }],
            };
        }
        
        
        
        const menuItems = AppMenuConfig.pages[this.props.route.components.page];
        
        return (
            <div>
                <div className="container">
                    <Link to={'/' + this.props.route.back}>
                        <div className="row">
                            <div className="col-md-2">
                                <i style={{ marginTop: 6 }} className="spark-icon-arrow-basic-left spark-icon--xd" />
                            </div>
                            <div className="col-md-10 link-to-home">Back</div>
                        </div>
                    </Link>
                </div>
                <LeftMainmenuItem icon="spark-icon-documents" title={this.props.route.menu} />
                <div className="container search__container" style={{ margin: '20 0' }}>
                    <Link to="/pages/search" activeClassName="active">
                        <div className="row">
                            <div className="col-md-2">
                                <i style={{ marginTop: 6 }} className={`spark-icon-search spark-icon`} />
                            </div>
                            <div className="col-md-10 leftnav-menu-item-copy">
                                <div className="row">
                                    <div className="col-md-12">
                                        <h4 style={{ marginBottom: 0 }}>Search</h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Link>
                </div>
                <div className="spark-panel__content leftnav-menu-submenu-container">
                    <nav
                        ref={node => (this.node = node)}
                        className="spark-menu spark-menu--panel col-xs-12 col-col-md-12 col-lg-12 col-xl-12"
                    >
                        <ul className="spark-menu__list">
                            {menuItems.map((elem, idx) => {
                                // workaround as the Spark FW sets a className "active" on the <li> elem
                                const active = `/pages/${elem.link}` === this.props.location.pathname;
                                const cssClassName = active ? 'spark-menu__list-item active' : 'spark-menu__list-item';
                                return (
                                    <li
                                        key={`item${idx}`}
                                        className={`${
                                            this.isLinkDisabled(elem) ? 'disabled-link' : ''
                                        } ${cssClassName}`}
                                    >
                                        <a
                                            disabled={this.isLinkDisabled(elem)}
                                            onClick={e => {
                                                this.clickOnLink(elem, e);
                                            }}
                                            className="spark-menu__list-link"
                                        >
                                            {elem.name}
                                        </a>
                                    </li>
                                );
                            })}
                        </ul>
                    </nav>
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = dispatch => ({
    modalGuestInfoActions: {
        show: () => dispatch(modalGuestInfoActions.show())
    },
    modalConfirmationSettingsActions: {
        show: comp => dispatch(modalConfirmationSettingsActions.show(comp))
    },
    modalLabelSettingsActions: {
        show: comp => dispatch(modalLabelSettingsActions.show(comp))
    }
});

NavigationPagesComponents.propTypes = {
    location: PropTypes.object
};

const mapStateToProps = state => {
    return {
        permissionLabels: checkPermissions(state, ACCESS_POINTS_GROUP.LABELS),
        permissionConfiguration: checkPermissions(state, ACCESS_POINTS_GROUP.CONFIGURATION),
        hasAccessToTrackingHooks: checkPermissions(state, ACCESS_POINTS_GROUP.TRACKING_HOOKS),
        inContextBeta: get(state, 'app.selected.inContextBeta', false)
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NavigationPagesComponents));



// WEBPACK FOOTER //
// ./src/components/pages/pages/NavigationPagesComponents.js